import { Link } from "@tanstack/react-router";
import { useT } from "@/lib/i18n";
import allGoods from "@/assets/farve/all-goods.jpg";
import wedding from "@/assets/farve/wedding.jpg";

export const aboutHeadDa = () => ({
  meta: [
    { title: "Om Farveladeland" },
    {
      name: "description",
      content:
        "Farveladeland er et københavnsk studie for vintage Murano-glas og udvalgte loppefund, samlet langsomt på rejser i Europa.",
    },
    { property: "og:title", content: "Om Farveladeland" },
    {
      property: "og:description",
      content: "Et københavnsk studie for vintage Murano-glas og loppefund.",
    },
    { property: "og:image", content: allGoods },
  ],
});

export const aboutHeadEn = () => ({
  meta: [
    { title: "About Farveladeland" },
    {
      name: "description",
      content:
        "Farveladeland is a Copenhagen-based studio for vintage Murano glass and curated flea-market finds, collected slowly on journeys across Europe.",
    },
    { property: "og:title", content: "About Farveladeland" },
    {
      property: "og:description",
      content: "A Copenhagen studio for vintage Murano glass and flea-market finds.",
    },
    { property: "og:image", content: allGoods },
  ],
});

export function AboutPage() {
  const { t } = useT();
  return (
    <>
      <section className="pt-40 pb-20 md:pt-52 md:pb-28">
        <div className="mx-auto max-w-[1500px] px-6 md:px-10">
          <p className="eyebrow">{t("about.eyebrow")}</p>
          <h1 className="mt-6 max-w-4xl font-display text-[clamp(3rem,7vw,6rem)] leading-[0.95] text-balance">
            {t("about.titleA")}
            <br />
            <em className="text-terracotta">{t("about.titleB")}</em>
          </h1>
        </div>
      </section>

      <section className="mx-auto max-w-[1500px] px-6 pb-32 md:px-10">
        <div className="grid gap-16 md:grid-cols-12">
          <div className="md:col-span-7">
            <div className="aspect-[5/6] overflow-hidden rounded-sm bg-muted">
              <img src={allGoods} alt="Et overblik over Farveladelands udvalg" loading="lazy" decoding="async" className="h-full w-full object-cover" />
            </div>
          </div>
          <div className="space-y-6 text-base leading-relaxed text-muted-foreground md:col-span-5">
            <p className="font-display text-3xl leading-snug text-foreground">{t("about.intro")}</p>
            <p>{t("about.p1")}</p>
            <p>{t("about.p2")}</p>
            <p>{t("about.p3")}</p>
            <Link
              to="/visit"
              className="mt-4 inline-flex items-center gap-3 rounded-full bg-foreground px-6 py-3.5 text-xs font-medium uppercase tracking-[0.2em] text-background hover:bg-terracotta"
            >
              {t("topbar.book")} →
            </Link>
          </div>
        </div>
      </section>

      <section className="relative overflow-hidden bg-foreground py-24 text-background md:py-32">
        <img
          src={wedding}
          alt=""
          aria-hidden
          loading="lazy"
          decoding="async"
          className="absolute inset-0 h-full w-full object-cover opacity-25"
        />
        <div className="relative mx-auto max-w-[1500px] px-6 md:px-10">
          <div className="grid gap-12 md:grid-cols-2">
            <div>
              <p className="eyebrow text-background/85">{t("about.believe.eyebrow")}</p>
              <h2 className="mt-4 font-display text-5xl leading-[1.05] md:text-6xl">
                {t("about.believe.titleA")}
                <br />
                <em className="text-background/85">{t("about.believe.titleB")}</em>
              </h2>
            </div>
            <ul className="space-y-6 text-base leading-relaxed text-background/80">
              {[
                t("about.believe.l1"),
                t("about.believe.l2"),
                t("about.believe.l3"),
              ].map((line) => (
                <li key={line} className="flex gap-4 border-t border-background/15 pt-6">
                  <span className="font-display text-2xl text-background/85">·</span>
                  <span>{line}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>
    </>
  );
}
